<template>
  <el-dialog
    :title="isEdit ? '编辑分类' : '新增分类'"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="categoryForm"
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="父级分类" v-if="!isEdit">
        <el-input :value="parentCategoryName" disabled placeholder="根分类" />
      </el-form-item>
      <el-form-item label="分类编码" prop="number">
        <el-input
          v-model="form.number"
          placeholder="同一销售组织下编码不能重复"
          :disabled="isEdit"
          maxlength="64"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="分类名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入分类名称"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="排序号" prop="sort">
        <el-input-number
          v-model="form.sort"
          :min="0"
          :max="9999"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch
          v-model="form.status"
          :active-value="1"
          :inactive-value="0"
          active-text="启用"
          inactive-text="禁用"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveSaleCategory, updateSaleCategory } from '@/api/system/sale_category'

export default {
  name: 'CategoryForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    },
    parentCategory: {
      type: Object,
      default: null
    },
    saleOrgId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        id: '',
        number: '',
        name: '',
        sort: 0,
        status: 1,
        parentId: '0',
        saleOrgId: ''
      },
      rules: {
        number: [
          { required: true, message: '请输入分类编码', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]+$/, message: '编码只能包含字母、数字和下划线', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      },
      submitLoading: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    isEdit() {
      return !!(this.formData && this.formData.id)
    },
    parentCategoryName() {
      return this.parentCategory ? this.parentCategory.name : '根分类'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm()
      }
    }
  },
  methods: {
    initForm() {
      if (this.isEdit) {
        // 编辑模式
        this.form = {
          id: this.formData.id,
          number: this.formData.number,
          name: this.formData.name,
          sort: this.formData.sort || 0,
          status: this.formData.status !== undefined ? this.formData.status : 1,
          parentId: this.formData.parentId,
          saleOrgId: this.formData.saleOrgId
        }
      } else {
        // 新增模式
        this.form = {
          id: '',
          number: '',
          name: '',
          sort: 0,
          status: 1,
          parentId: this.parentCategory ? this.parentCategory.id : '0',
          saleOrgId: this.saleOrgId
        }
      }
      this.$nextTick(() => {
        this.$refs.categoryForm && this.$refs.categoryForm.clearValidate()
      })
    },

    handleSubmit() {
      this.$refs.categoryForm.validate(async (valid) => {
        if (!valid) return

        this.submitLoading = true
        try {
          let res
          if (this.isEdit) {
            res = await updateSaleCategory(this.form)
          } else {
            res = await saveSaleCategory(this.form)
          }

          if (res.code === 200) {
            this.$message.success(this.isEdit ? '修改成功' : '新增成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(res.msg || (this.isEdit ? '修改失败' : '新增失败'))
          }
        } catch (error) {
          console.error('保存分类失败:', error)
          this.$message.error('保存分类失败')
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.$refs.categoryForm && this.$refs.categoryForm.resetFields()
    }
  }
}
</script>
